import {
  BooleanStateVariable,
  NumberStateVariable,
  RawStateVariable,
  StateVariable,
  TextStateVariable,
} from './types';

export const formatStateVariable = (
  state_variable: RawStateVariable
): StateVariable => {
  if (state_variable.type === 'string') {
    return {
      ...state_variable,
      type: 'string',
      value: state_variable.value || state_variable.defaultValue || '',
    };
  } else if (state_variable.type === 'number') {
    const string_value = state_variable.value || state_variable.defaultValue;
    let value: number | undefined = undefined;

    if (string_value?.length) {
      try {
        value = parseInt(string_value);
      } catch (ex) {
        value = undefined;
      }
    }

    return {
      ...state_variable,
      type: 'number',
      value,
    };
  } else {
    const value = state_variable.value || state_variable.defaultValue;

    return {
      ...state_variable,
      type: 'boolean',
      value: value === 'true' ? true : value === 'false' ? false : undefined,
    };
  }
};

export const findStateVariableByName = (
  state_variables: StateVariable[],
  name: string
) => state_variables.find((sv) => sv.name === name);

export const findTextStateVariableByName = (
  state_variables: StateVariable[],
  name: string
) =>
  state_variables.find((sv) => sv.type === 'string' && sv.name === name) as
    | TextStateVariable
    | undefined;

export const findNumberStateVariableByName = (
  state_variables: StateVariable[],
  name: string
) =>
  state_variables.find((sv) => sv.type === 'number' && sv.name === name) as
    | NumberStateVariable
    | undefined;

export const findBooleanStateVariableByName = (
  state_variables: StateVariable[],
  name: string
) =>
  state_variables.find((sv) => sv.type === 'boolean' && sv.name === name) as
    | BooleanStateVariable
    | undefined;


export const stateVariableFunctions = (state_variables: StateVariable[]) => {
  return {
    findTextVariable: (name: string) =>
      findTextStateVariableByName(state_variables, name),
    findNumberVariable: (name: string) =>
      findNumberStateVariableByName(state_variables, name),
    findBooleanVariable: (name: string) =>
      findBooleanStateVariableByName(state_variables, name),
  };
};